import React from 'react';
import s from './index.module.scss';

import { Header } from './components/header';
import { Logo } from '../logo';
import { Description } from './components/description';
import { Price } from './components/price';
import { PriceV2 } from './components/priceV2';
import { SkipBtn } from './components/skipBtn';
import PaymentModal from './components/paymentModal';
import { getParameterFromURL } from '../../../utils/scripts';

export const PDFUpselling = () => {
  const ppPDFV2 = getParameterFromURL("ppPDFV2");
  const paypalSuccessPayment = window.paypalPayment;

  return (
    <section className={s.wrapper}>
      <Logo />
      <div className={s.container}>
        <Header />
        <div className={s.content}>
          <Description />
          {ppPDFV2 && paypalSuccessPayment ? <PriceV2 /> : <Price />}
          <PaymentModal />
          <SkipBtn />
        </div>
      </div>
    </section>
  );
};
